/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
/* eslint-disable import/order */
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { NAVIGATION_UI_STORAGE_KEY } from '@jira/router-resources__navigation-ui-state/src/navigationUiStorageKey.constants.tsx';
import { setUserProperties } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import type {
	LeftSidebarState,
	PreviewPanelState,
	RightSidebarState,
} from '../../../../../common/types.tsx';

export type RemoteLayoutState = {
	leftSidebar: Pick<LeftSidebarState, 'isCollapsed' | 'width'>;
	rightSidebar: RightSidebarState;
	previewPanel?: PreviewPanelState;
};

export async function setRemoteLayoutState({
	accountId,
	state,
}: {
	accountId: string;
	state: RemoteLayoutState;
}): Promise<void> {
	try {
		await setUserProperties(accountId, NAVIGATION_UI_STORAGE_KEY, JSON.stringify(state));
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (e: any) {
		fireErrorAnalytics({
			error: e,
			meta: {
				id: 'updateServerLayoutState',
				packageName: 'jiraLayoutController',
				teamName: 'jfp-team',
			},
		});
	}
}
